import React from "react";
import {
  MainButton,
  useShowPopup,
  BackButton,
} from "@vkruglikov/react-telegram-web-app";
import SwapWidget from "@native_org/widgets";

function App() {
  const showPopup = useShowPopup();

  const handleClick = () =>
    showPopup({
      message: "Hello, I am popup",
    });

  return (
    <div className="App">
      <header className="App-header">
        <h1>Swap Menu</h1>
        <SwapWidget
          apiKey="JWL73SF2K899AMPFRHZV"
          // walletSettings={{
          //   usingNative: false,
          //   address: walletAddress,
          //   chainId: blockchainMetadata?.chainIdHex,
          //   connect: () => connect(),
          //   provider: provider,
          //   setChain: ({ chainId }: { chainId: string | number }) => setChain(chainId),
          // }}
          theme={{
            theme: "dark",
            bg: {
              page: "#111423",
              primary: "#111423",
              secondary: "#23273A",
              cta: "#FFEE05",
            },
            text: {
              primary: "#ffffff",
              secondary: "#9CA3AF",
              border: "#50515a",
              borderLight: "#50515a",
              cta: "#FFEE05",
            },
          }}
          containerStyle={{
            width: "100%",
            ".native-bt-contained": {
              color: "#111423",
            },
            ".native-bt-contained:disabled": {
              color: "#9CA3AF",
            },
            ".native-bt-contained.native-max-button": {
              color: "#ffffff",
            },
          }}
          chainSettings={{
            1: {
              isSupported: true,
            },
            56: {
              isSupported: true,
            },
            137: {
              isSupported: true,
            },
          }}
        />
        <MainButton text="Show Popup" onClick={handleClick} />
        <BackButton />
      </header>
    </div>
  );
}

export default App;
